<template>
    <v-container class="py-3 fill-height">
        <v-layout wrap fill-height align-center justify-center>
            <v-flex xs12 text-xs-center>
                <v-layout wrap class="content py-3" justify-center align-center>

                    <v-scale-transition>
                        <v-layout wrap v-show="!currentUser">

                            <v-flex xs12 text-xs-center>
                                <v-img class="mx-auto" :src="require('@/assets/img/logo_light.png')" width="100%"
                                       contain max-width="300"/>
                            </v-flex>

                            <v-flex xs12 text-xs-center mt-3>
                                <v-layout wrap justify-center>
                                    <v-flex xs12 md8 lg4 text-xs-center>
                                        <standalone-login-client-form v-on:success="onLoginSuccess"/>
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                        </v-layout>
                    </v-scale-transition>

                </v-layout>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
import {mapState} from 'vuex'
import StandaloneLoginClientForm from "@/components/common/StandaloneLoginClientForm";

export default {
    components: {
        StandaloneLoginClientForm,
    },
    data() {
        return {
            showSpecialistSignUp: false
        }
    },
    computed: {
        ...mapState(['currentUser', 'firstLoadingLogin']),
    },
    methods: {
        onLoginSuccess() {
            this.$router.replace({
                name: 'panel.dashboard'
            })
        },
        onChange(show) {
            this.showSpecialistSignUp = show
        },
    }
}
</script>

<style scoped>

.content {
    position: relative;
    z-index: 10;
}

</style>
